import React, { useState } from "react";
import { FaCamera, FaUser } from "react-icons/fa";

const CircleAvatar = ({ size = 100, onImageSelect, imageUrl }) => {
  const [localImage, setLocalImage] = useState(null);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setLocalImage(reader.result); // Vista previa local de la imagen
      };
      reader.readAsDataURL(file);
      if (onImageSelect) onImageSelect(event); // Pasa el evento al padre
    }
  };

  return (
    <div className="relative" style={{ width: size, height: size }}>
      {/* Avatar Circle */}
      <div
        className="rounded-full overflow-hidden border"
        style={{
          width: size,
          height: size,
          backgroundColor: "#5C2E91",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {localImage || imageUrl ? (
          <img
            src={localImage || imageUrl}
            alt="Profile"
            className="w-full h-full object-cover"
          />
        ) : (
          <FaUser size={size / 2} color="#E5960E" />
        )}
      </div>

      {/* Camera Icon */}
      <label
        htmlFor="avatar-upload"
        className="absolute bottom-0 right-0 bg-green-500 text-white p-2 rounded-full cursor-pointer hover:bg-green-600"
        style={{ transform: "translate(-5%, 0%)" }}
      >
        <FaCamera />
        <input
          type="file"
          id="avatar-upload"
          accept="image/*"
          className="hidden"
          onChange={handleImageChange}
        />
      </label>
    </div>
  );
};

export default CircleAvatar;
